<template>
  <div class="calico-credit-risk-rating">
    <h2
      class="heading--medium"
      :class="colorClass"
    >
      {{ creditRiskRating }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'CalicoCreditRiskRating',
  props: {
    creditRiskRating: {
      type: String,
      default: '',
    }
  },
  computed: {
    colorClass() {      
      return {
        'Minimal Risk': 'credit-risk-1',
        'Modest Risk': 'credit-risk-2',
        'Average Risk': 'credit-risk-3',
        'Active Monitor': 'credit-risk-4',
        'Special Mention': 'credit-risk-5',
        'Watch List': 'credit-risk-6',
        'Substandard': 'credit-risk-7'
      }[this.creditRiskRating]
    }
  }
}
</script>

<style scoped lang="scss">
.calico-credit-risk-rating {
  .credit-risk-1 { color: $color-green-dark; }
  .credit-risk-2 { color: $color-cyan-dark; }
  .credit-risk-3 { color: $color-yellow-dark; }
  .credit-risk-4 { color: $color-pink; }
  .credit-risk-5 { color: $color-orange-dark; }
  .credit-risk-6 { color: $color-red-dark; }
  .credit-risk-7 { color: $color-black; }
}
</style>
